import { useEffect, useRef, useState } from 'react';
import { Button, Input, message } from 'antd';
import { WordCloud } from '@antv/g2plot';
import axios from 'axios';
import { debounce } from 'lodash-es';

const { TextArea } = Input;

const Participles = () => {
  const container = useRef<HTMLDivElement>(null);
  const [content, setContent] = useState('');
  const [dict, setDict] = useState(localStorage.getItem('dict') || '');
  const [data, setData] = useState<Record<string, number | string>[]>([]);
  const [loading, setLoading] = useState(false);

  const getParticiples = async () => {
    const v = content.trim();
    const d = dict.trim();
    localStorage.setItem('dict', d);
    if (!v) return message.warning('内容不能为空');
    setLoading(true);
    try {
      const result = await axios.post('/api/participles', {
        content: v.replace(/\s/g, ','),
        dict: d,
      })
      .then(res => res.data)
      .catch(err => message.error(err.message));
      if (!result) return;
      const words: Record<string, number> = { };
      result.forEach((word: string) => {
        if ([',', '，', '.', '。', ' '].includes(word)) return;
        if (words[word]) {
          words[word]++;
        } else {
          words[word] = 1;
        }
      });
      const c = Object.keys(words).map(word => ({
        x: word,
        value: words[word],
      }));
      setData(c);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!container.current) return;
    const wordCloud = new WordCloud(container.current, {
      data,
      wordField: 'x',
      weightField: 'value',
      colorField: 'x',
      wordStyle: {
        fontFamily: 'Verdana',
        fontSize: [8, 64],
        rotation: 0,
      },
      random: () => 0.5,
    });
    wordCloud.render();
    const obs = new ResizeObserver(debounce(wordCloud.render, 500));
    obs.observe(container.current);
    return () => {
      obs.disconnect();
      wordCloud.destroy();
    };
  }, [data]);

  return (
    <div>
      <div style={{ display: 'flex', gap: 16 }}>
        <TextArea style={{ height: 240, resize: 'none' }} value={content} onChange={e => setContent(e.target.value)} placeholder="内容" />
        <TextArea style={{ height: 240, resize: 'none' }} value={dict} onChange={e => setDict(e.target.value)} placeholder="词典，一行一个词" />
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button
          type="primary"
          style={{ marginTop: 16 }}
          onClick={getParticiples}
          disabled={!content.trim()}
          loading={loading}
        >
          获取词云
        </Button>
      </div>
      <div ref={container} style={{ marginTop: 16, height: 600 }} />
    </div>
  );
};

export default Participles;
